import { Block } from 'baseui/block';
import { generatePath, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { FLEET_DRIVER_PAGE } from '../../../constants/fleet';
import { useStyles } from '../../../hooks/useStyles';
import { isAllWorkspacesSelect } from '../../../storage/app';
import { FleetDriverTab, GorilaDriver } from '../../../types/drivers';
import { getDriverFullName, isGorilaDriver, isUnknownDriver } from '../../../utils/drivers';
import { StyledTooltip } from '../../ui/StyledTooltip';
import FleetDriverAvatar from '../drivers/driver/FleetDriverAvatar';

type Props = Readonly<{ driver?: GorilaDriver }>;

function FleetCurrentDriver({ driver }: Props) {
  const { css } = useStyles();
  const { id: workspaceId } = useParams();
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const wrapperStyles = css({
    position: 'relative',
    alignSelf: 'center',
    cursor: driver?.driverId && !isAllWorkspacesSelected ? 'pointer' : 'none',
  });
  const registeredAvatarStyles = css({
    position: 'absolute',
    bottom: 0,
    right: 0,
    transform: 'translate(25%, 25%)',
  });

  if (!isGorilaDriver(driver)) {
    return null;
  }

  let { name, lastName, detectedKey, key: photoKey, driverId } = driver;

  if (!photoKey && !detectedKey) {
    return null;
  }

  name = name || '';
  lastName = lastName || '';
  const hasPhotos = !!photoKey && !!detectedKey;

  return (
    <StyledTooltip
      content={isUnknownDriver(driver) ? 'Pendiente de identificar' : getDriverFullName(driver)}
      ignoreBoundary
      placement="top"
      showArrow={false}
    >
      <Block
        className={wrapperStyles}
        onClick={() => {
          if (!driverId || isAllWorkspacesSelected) return;
          const route = generatePath(FLEET_DRIVER_PAGE.route, {
            id: workspaceId,
            driverId,
            tab: FleetDriverTab.general,
          });
          window.open(route, '_blank');
        }}
      >
        <FleetDriverAvatar
          name={name}
          lastName={lastName}
          photo={hasPhotos ? detectedKey : detectedKey || photoKey}
          size="48px"
          disableFullScreen
        />
        {hasPhotos && (
          <span className={registeredAvatarStyles}>
            <FleetDriverAvatar
              name={name}
              lastName={lastName}
              photo={photoKey}
              size="25px"
              fontSize="14px"
              disableFullScreen
            />
          </span>
        )}
      </Block>
    </StyledTooltip>
  );
}

export default FleetCurrentDriver;
